﻿import './vendor/lib/rangeslider/rangeslider.js';
//import './vendor/lib/daterangepicker/opacc.daterangepicker.js';
//import './vendor/lib/daterangepicker/locales/de.js';
import { InputFilter } from './opacc.class.filter-input.js';
import { SelectFilter } from './opacc.class.filter-select.js';
import { RangeFilter } from './opacc.class.filter-range.js';
//import { DatePickerFilter } from './opacc.class.filter-datepicker.js';
import { opaccFilterCriterias } from './opacc.class.filter-criterias.factory.js';

export class OpaccFilter {
  constructor() {
    this.filterObjects = [];
    this.wrapperElement = document.querySelector('.content');

    this.attachEventListener();
  }

  attachEventListener() {
    this.toggleFilterItem();
  }

  toggleFilterItem() {
    this.wrapperElement.addEventListener('click', e => {
      let filterWrapper =  this.wrapperElement.querySelector('.opc-filter-set .filter-set-list');   
      if (filterWrapper) {
        let listSelector = e.target.closest('.filter-body-inner');
        let filterSearchContentSelector = e.target.closest('.filter-body-search');
        let filterSetList = e.target.closest('.filter-head');
        let filterElem = e.target.closest('.opc-filter');

        let filterTagList = e.target.closest('.filter-set-selection');
        
        // close open-Filter
        let filterToggleMobile = this.wrapperElement.querySelector('.filter-toggle');   
        // check if is Mobile-view and toggle filter-list
        if (e.target === filterToggleMobile) {
          filterWrapper.classList.toggle('is-open');
        }

        // close all Open Filter
        let currentOpenFilterElem = filterWrapper.querySelector('.opc-filter.is-open[data-op-style="dropdown"]');
        if (currentOpenFilterElem && !filterSearchContentSelector && !listSelector) {
          currentOpenFilterElem.classList.remove('is-open');
        } 
        let allOpenFilterElems = filterWrapper.querySelectorAll('.opc-filter.is-open[data-op-style="dropdown"]');

        // Filter-Click-Event
        if (filterElem) {
          if (filterSetList) {
            //check if Filter is Dropdown-Filter
            let filterItem = filterSetList.closest('.opc-filter[data-op-style="dropdown"]');
            if (filterItem) {
              // Open filter if clicked Filter != previously closed Filter
              if (filterItem != currentOpenFilterElem) {
                // close all other Filters
                Array.from(allOpenFilterElems).forEach(item => {
                  item.classList.remove('is-open');
                });

                filterItem.classList.add('is-open');
              }
            }
          }
          
          let isRangeFilter = (filterElem.dataset.opType === 'range') ? true : false;
          let isDatePickerFilter = (filterElem.dataset.opType === 'datepicker') ? true : false;
          if (!this.filterObjects[filterElem.id] ||
             (isRangeFilter && !filterElem.classList.contains('js-init')) || 
             (isDatePickerFilter && !filterElem.classList.contains('js-init'))) {
            let filterObj = undefined;
            switch (filterElem.dataset.opType) {
            case 'text':
                filterObj = new InputFilter(filterElem, this.wrapperElement);
              break;
            case 'range':
              filterObj = new RangeFilter(filterElem, this.wrapperElement);
              filterElem.classList.add('js-init');
              break;
            case 'datepicker':
              // filterObj = new DatePickerFilter(filterElem, this.wrapperElement);
              // filterElem.classList.add('js-init');
              break;
            default:
              filterObj = new SelectFilter(filterElem, this.wrapperElement);
              break;
            }
            this.filterObjects[filterElem.id] = filterObj;
          }
  
          // Select Item or Search within Filter
          if (listSelector || filterSearchContentSelector) {
            // nur Labels werden weiter verarbeitet
            if (e.target.matches('label')) {
              this.filterObjects[filterElem.id].selectValueByTargetAndSetFilterCriterias(e.target);
            } else if (e.target.matches('.op-form-input')) {
              this.filterObjects[filterElem.id].searchValue(filterElem);
            }
          }
        }
        // Deselect Filter by Tag-List
        if (filterTagList || filterElem) {
          
          let selectedAttribute = (e.target.getAttribute('data-op-filterattr')) ? e.target.dataset.opFilterattr : undefined;
          if (e.target.matches('.tag-remove')) {
            opaccFilterCriterias.remove(selectedAttribute, e.target.dataset.opItemvalue);
          } else if (e.target.matches('.filter-reset')) {
            opaccFilterCriterias.remove(selectedAttribute);
          }
        }
      }
    }, false);
  }
}




